import { createApi } from '@reduxjs/toolkit/query/react';
import { endPoints } from 'src/api/APIEndpoints';
import { IStudies } from 'src/types/Utils';
import { formatString } from 'src/util/STR';
import { baseQueryETMFUtils } from './baseQuery';
//import {} from '../types/Utils';
// import { baseQueryUtils } from './baseQueryUtils';

export const utilsApi = createApi({
  baseQuery: baseQueryETMFUtils,
  reducerPath: 'utilsApi',
  endpoints: builder => ({
    getStudies: builder.query<IStudies, void>({
      query: () => ({
        url: formatString(endPoints.Utils.selectStudies) + `?application=ETMF`,
        method: 'GET'
      })
    }),
    getCountries: builder.query<IStudies, string>({
      query: studyID => ({
        url: formatString(endPoints.Utils.selectCountries) + `?application=ETMF&study_id=${studyID}`,
        method: 'GET'
      })
    }),
    getSites: builder.query<IStudies, { currentStudy: string; currentCountry: string }>({
      query: ({ currentStudy, currentCountry }) => ({
        url:
          formatString(endPoints.Utils.selectSites) +
          `?application=ETMF&study_id=${currentStudy}&country=${currentCountry}`,
        method: 'GET'
      })
    })
  })
});

export const { useGetStudiesQuery, useGetCountriesQuery, useGetSitesQuery } = utilsApi;
